// extracted by mini-css-extract-plugin
export default {"customer-details-row":"Xs0c3","customerDetailsRow":"Xs0c3","text":"qAbJv"};